<template lang="pug">
div
  Form(:data="worker", :isSubmitting="isSubmitting", :isPCUploadVisible="false", :isEdit="true", @submit="update")
  WorkerPermissions(
    v-if="worker._id && role === 'consultant'"
    :isLoading="permIsLoading"
    :groups="permGroups"
    :expanded="permExpanded"
    :allExpanded="permAllExpanded"
    :hasOverrides="permHasOverrides"
    :toggleAll="permToggleAll"
    :viewMode="permViewMode"
    :setViewMode="permSetViewMode"
    :toggleAction="permToggleAction"
    :resetOverride="permResetOverride"
  )
</template>

<script>
import { onMounted, watch, getCurrentInstance } from '@vue/composition-api'
import useWorkerPermissionOverride from '@/composables/useWorkerPermissionOverride'
import i18n from '@/libs/i18n'
import store from '@/store'
import Form from '../shared/Form.vue'
import WorkerPermissions from './WorkerPermissions.vue'
// eslint-disable-next-line import/no-cycle
import useWorkerEdit from './useWorkerEdit'

export default {
  components: {
    Form,
    WorkerPermissions,
  },

  setup() {
    const {
      update, show, worker, isSubmitting,
    } = useWorkerEdit()
    const { proxy } = getCurrentInstance()
    const { role } = store.state?.userStore?.userData

    const {
      isLoading: permIsLoading,
      groups: permGroups,
      expanded: permExpanded,
      allExpanded: permAllExpanded,
      toggleAll: permToggleAll,
      viewMode: permViewMode,
      setViewMode: permSetViewMode,
      toggleAction: permToggleAction,
      hasOverrides: permHasOverrides,
      resetOverride: rawResetOverride,
      fetchDefault,
    } = useWorkerPermissionOverride(worker)

    onMounted(show)

    // El select de Privilegios (dentro de Form.vue) escribe sobre el mismo objeto `worker`
    // que se le pasa por prop — este watch reacciona en vivo, antes de guardar el formulario.
    // Si el worker no tenía overrides, el cambio es automático. Si tenía, se confirma antes
    // de borrarlos (misma acción que "Restablecer a valores por defecto"); si se cancela, el
    // select vuelve al valor anterior.
    let isReverting = false

    watch(() => worker.value.privileges, async (newPrivilege, oldPrivilege) => {
      if (isReverting) {
        isReverting = false
        return
      }
      // Los permisos por worker (WorkerPermissions.vue) son exclusivos de consultant — para
      // cualquier otro privilegio ni se muestra la sección ni se toca worker_permission_override
      // acá, aunque el select de Privilegios (en Form.vue) sea editable para otros roles.
      if (role !== 'consultant') return
      if (!oldPrivilege || newPrivilege === oldPrivilege) return

      if (permHasOverrides.value) {
        const confirmed = await proxy.$bvModal.msgBoxConfirm(
          i18n.t('message.confirm_privilege_change_permissions'),
          {
            title: i18n.t('message.confirm_action'),
            okVariant: 'danger',
            okTitle: i18n.t('message.yes'),
            cancelTitle: i18n.t('message.cancel'),
            centered: true,
          },
        )

        if (!confirmed) {
          isReverting = true
          worker.value.privileges = oldPrivilege
          return
        }

        await rawResetOverride()
      }

      await fetchDefault(newPrivilege)
    })

    return {
      worker,
      update,
      isSubmitting,
      role,
      permIsLoading,
      permGroups,
      permExpanded,
      permAllExpanded,
      permToggleAll,
      permViewMode,
      permSetViewMode,
      permToggleAction,
      permHasOverrides,
      permResetOverride: rawResetOverride,
    }
  },
}
</script>
